<template>
    <Page :header="content[lang_].title" :header_pos="'center'">
        <template #body>
            <div class="flex flex flex-column align-items-center justify-content-center">
                <div class="flex max-w-30rem w-full">
                    <form @submit.prevent="handleSubmit(!v$.$invalid)" class="flex flex-column  w-full p-fluid">
                        <!--PASS-->
                        <div class="field mt-2 mb-2 ">
                            <span class="text-color-secondary">{{ content[lang_].email }}:</span>
                            <div class="p-float-label p-input-icon-right">
                                <IconField iconPosition="right" class="w-full">
                                    <InputText id="email" v-model="v$.remail.$model" aria-describedby="email-error"
                                        :class="{'p-invalid':v$.remail.$invalid && submitted}" class='p-inputtext-lg mt-2 mb-2 w-full border-2 border-round-lg'/>
                                    <InputIcon class="pi pi-envelope mr-2" /> 
                                </IconField>
                            </div>
                            <span v-if="v$.remail.$error && submitted">
                                <span id="email-error" v-for="(error, index) of v$.remail.$errors" :key="index">
                                <small class="p-error">{{error.$message}}</small>
                                </span>
                            </span>
                            <small v-else-if="(v$.remail.$invalid && submitted) || v$.remail.$pending.$response" class="p-error">{{v$.remail.required.$message.replace('Value', 'Email')}}</small>
                        </div>

                        <Button type="submit" :label="content[lang_].button" class="mt-2 p-button-lg w-full border-round-lg" :loading="isLoading"/>

                        <Divider />
                    </form>
                </div>

                <div class="flex justify-content-center flex-wrap card-container yellow-container">
                    <div class="flex align-items-center justify-content-center w-full m-2">
                        <Button :label="content[lang_].registation" @click="go_reg" text severity="info"/>
                        <Button :label="content[lang_].sign_in" @click="go_auth" text severity="info"/>
                    </div>
                </div>

			</div>
        </template>
    </Page>
</template>


<script>
import Connect from '@/assets/js/Connect'
import Event from '@/assets/js/Event'
import Page from '@/components/sides/Page.vue'
import { useVuelidate } from '@vuelidate/core'
import { email, required } from '@vuelidate/validators'
import { mapActions } from  'vuex'

export default {
    data() {
        return {
            content:{
                en: {
                    email: "Email",
                    title: "Forgot Password",
                    button: "Restore",
                    sign_in : "Sign In",
                    registation: "Registration",
                    success_title: "Success",
                    success_subtitle: "Check your mail",
                } ,
                ru: {
                    email: "Email",
                    title: "Восстановление пароля", 
                    button: "Восстановить",
                    sign_in : "Войти",
                    registation: "Регистрация",
                    success_title: "Успешно",
                    success_subtitle: "Проверьте почту",
                } ,
            },
            remail: null,
            accept: null,
            submitted: false,
            showMessage: false,
            v$: useVuelidate(),
            isLoading: false
        }
    },
    validations() {
        return {
            remail: {
                required, email
            },
        }
    },
    components: {
        Page,
    },
    computed: {
        lang_() {return (this.$i18n.locale) ? this.$i18n.locale : 'ru'},
        isAuth: function () { return this.$store.getters.isAuthenticated },
    },
    watch: {
        remail:function(email){
            this.remail=email.toLowerCase()
        },
    },
    methods: {
        ...mapActions(['SetHeaderTitle', 'SetHeaderBtnLeftFirst', 'SetHeaderBtnLeftSecond', 'SetHeaderBtnRightFirst', 'SetHeaderBtnRightSecond']),
        go_reg(){
            this.event.send('regBtn')
            this.$router.push({
                path: '/reg/'
            })
        },
        go_auth(){
            this.event.send('loginBtn')
            this.$router.push({
                path: '/auth/'
            })
        },
        showMess(severity, summary, detail) {
            this.$toast.add({severity: severity, summary: summary, detail: detail, life: 3000});
        },
        async handleSubmit(isFormValid) {
            this.submitted = true
            this.isLoading = true

            if (!isFormValid) {
                this.isLoading = false
                return
            }

            this.event.send('forgotPass')

            const forgot = await this.connect.forgot_pass(this.remail).then(res=>res)
            if(forgot.result) {
                this.isLoading = false
                this.submitted = false
                this.remail = ''
                this.showMess('success', this.content[this.lang_].success_title, this.content[this.lang_].success_subtitle)
            }
            if(forgot.errors) {
                for (let i = 0; i < forgot.errors.length; i++) {
                    this.showMess('error', 'Error', forgot.errors[i])
                }
                this.isLoading = false
                this.submitted = false
            }
        },
        resetForm() {
            this.email = '';
            this.accept = null;
            this.submitted = false;
        }
    },
    beforeCreate () {
        this.connect = new Connect()
        this.event = new Event(this)
    },
    mounted(){
        if(this.isAuth) this.$router.push({ path: '/' })

        try {
            this.SetHeaderTitle(null)
            this.SetHeaderBtnLeftFirst({
                type: 'backward',
                icon: 'pi pi-arrow-left',
                class: 'text-xs',
                rounded: true,
                severity: 'secondary',
                visible: true,
            })
            this.SetHeaderBtnLeftSecond({})
            this.SetHeaderBtnRightFirst({
                type: 'link',
                link: '/auth/',
                label: this.content[this.lang_].sign_in,
                icon: 'pi pi-sign-in',
                iconPos: 'right',
                severity: 'secondary',
                class: '',
                rounded: true,
                visible: true
            })
            this.SetHeaderBtnRightSecond({})
        } catch (error) {
            console.error('Error setting header:', error)
        }
    },
}
</script>